var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRDownloadButtonIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5645 7.50922C14.5707 7.50918 14.5769 7.50918 14.5832 7.50918C16.6543 7.50918 18.3332 9.19117 18.3332 11.2661C18.3332 13.1998 16.8748 14.7923 14.9998 15M14.5645 7.50922C14.5768 7.37172 14.5832 7.23247 14.5832 7.09174C14.5832 4.55579 12.5312 2.5 9.99984 2.5C7.60254 2.5 5.63511 4.34389 5.43352 6.69327M14.5645 7.50922C14.4793 8.45633 14.107 9.3205 13.5355 10.0138M5.43352 6.69327C3.31982 6.89478 1.6665 8.67825 1.6665 10.8486C1.6665 12.8681 3.09797 14.5527 4.99984 14.9394M5.43352 6.69327C5.56505 6.68073 5.69836 6.67431 5.83317 6.67431C6.77135 6.67431 7.63712 6.98495 8.33359 7.50918",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 17.5V10.8333M9.99984 17.5C9.41634 17.5 8.32611 15.8381 7.9165 15.4167M9.99984 17.5C10.5833 17.5 11.6736 15.8381 12.0832 15.4167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRDownloadButtonIcon);
export default __webpack_public_path__ + "static/media/r-download-button-icon.4f88d77ed545daad7e2bcee4fa55660d.svg";
export { ForwardRef as ReactComponent };